import { bl_fi_my_einvoice_from_irb_document_cache_RowClass } from '../../dbschema/bl_fi_my_einvoice_from_irb_document_cache.model';
import { BaseContainerModel } from '../base-container.model';

export class FromIRBDocumentCacheContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_from_irb_document_cache: bl_fi_my_einvoice_from_irb_document_cache_RowClass = new bl_fi_my_einvoice_from_irb_document_cache_RowClass();
}